export default __webpack_public_path__ + "228efa7.png";